import { useI18n } from '../context/I18nContext';
import { fr, enUS } from 'date-fns/locale';

export const useDateLocale = () => {
  const { language } = useI18n();
  
  return language === 'fr' ? fr : enUS;
};


















